import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from "react-query";
import { setupAuthInterceptor } from './services/utils/auth-interceptor';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: true,
            retry: (failureCount, error: any) => {
                // Retry only once for network errors
                if (
                    error?.message === 'Network Error' || 
                    !navigator.onLine ||
                    !error.response
                ) {
                    return failureCount < 3;
                }
                return false; // Don't retry for other errors
            },
            retryDelay: 3000,
        }
    }
});

setupAuthInterceptor();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient} contextSharing={true}>
            <App/>
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
